import React, { useEffect, useState } from "react";
import "./style.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import ScrollTrigger from "react-scroll-trigger";
import CountUp from "react-countup";
import HomeCard, {
  Gallery,
  HomeTop,
  NewsBlog,
  StudentAchiev,
  StudentAchievment,
} from "./MultiCarousel";
import { Masonry } from "react-masonry";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useNavigate } from "react-router-dom";
// import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"

const home = {
  homeSlider: [
    {
      title:
        '<p>A Tradition of <span style="color:green; text-decoration: underline;">Excellence</span> that emphasizes on much and not many</p>',
      text: "Mauris malesuada enim eget blandit gravida. Duis hendrerit cursus turpis, id mollis est rutrum nec. Sed interdum nisi id libero tinci",
      url: "#",
      backGround: `${require("../images/home/topSlider.png")}`,
      img: `${require("../images/home/b1.png")}`,
    },
    // {
    //     title :'<p> <span style="color:green; text-decoration: underline;"> discover  </span> yourself</p>',
    //     text :'Mauris malesuada enim eget blandit gravida. Duis hendrerit cursus turpis, id mollis est rutrum nec. Sed interdum nisi id libero tinci',
    //     url:'#',
    //     backGround:`${require('../images/home/topSlider.png')}`,
    //     img:`${require('../images/home/b7.png')}`
    // },
    {
      title:
        '<p>A Tradition of <span style="color:green; text-decoration: underline;">Excellence</span> that emphasizes on much and not many</p>',
      text: "Mauris malesuada enim eget blandit gravida. Duis hendrerit cursus turpis, id mollis est rutrum nec. Sed interdum nisi id libero tinci",
      url: "#",
      backGround: `${require("../images/home/topSlider.png")}`,
      img: `${require("../images/home/b3.png")}`,
    },
    {
      title:
        '<p>A Tradition of <span style="color:green; text-decoration: underline;">Excellence</span> that emphasizes on much and not many</p>',
      text: "Mauris malesuada enim eget blandit gravida. Duis hendrerit cursus turpis, id mollis est rutrum nec. Sed interdum nisi id libero tinci",
      url: "#",
      backGround: `${require("../images/home/topSlider.png")}`,
      img: `${require("../images/home/b2.png")}`,
    },

    {
      title:
        '<p>A Tradition of <span style="color:green; text-decoration: underline;">Excellence</span> that emphasizes on much and not many</p>',
      text: "Mauris malesuada enim eget blandit gravida. Duis hendrerit cursus turpis, id mollis est rutrum nec. Sed interdum nisi id libero tinci",
      url: "#",
      backGround: `${require("../images/home/topSlider.png")}`,
      img: `${require("../images/home/b4.png")}`,
    },
    {
      title:
        '<p>A Tradition of <span style="color:green; text-decoration: underline;">Excellence</span> that emphasizes on much and not many</p>',
      text: "Mauris malesuada enim eget blandit gravida. Duis hendrerit cursus turpis, id mollis est rutrum nec. Sed interdum nisi id libero tinci",
      url: "#",
      backGround: `${require("../images/home/topSlider.png")}`,
      img: `${require("../images/home/b5.png")}`,
    },
    {
      title:
        '<p>A Tradition of <span style="color:green; text-decoration: underline;">Excellence</span> that emphasizes on much and not many</p>',
      text: "Mauris malesuada enim eget blandit gravida. Duis hendrerit cursus turpis, id mollis est rutrum nec. Sed interdum nisi id libero tinci",
      url: "#",
      backGround: `${require("../images/home/topSlider.png")}`,
      img: `${require("../images/home/b6.png")}`,
    },   
    {
      title:
        '<p>A Tradition of <span style="color:green; text-decoration: underline;">Excellence</span> that emphasizes on much and not many</p>',
      text: "Mauris malesuada enim eget blandit gravida. Duis hendrerit cursus turpis, id mollis est rutrum nec. Sed interdum nisi id libero tinci",
      url: "#",
      backGround: `${require("../images/home/topSlider.png")}`,
      img: `${require("../images/home/Frame 19.png")}`,
    },   
    {
      title:
        '<p>A Tradition of <span style="color:green; text-decoration: underline;">Excellence</span> that emphasizes on much and not many</p>',
      text: "Mauris malesuada enim eget blandit gravida. Duis hendrerit cursus turpis, id mollis est rutrum nec. Sed interdum nisi id libero tinci",
      url: "#",
      backGround: `${require("../images/home/topSlider.png")}`,
      img: `${require("../images/home/Frame 20.png")}`,
    },   
  ],

  iconCard: [
    {
      icon: `${require("../images/home/awesome.png")}`,
      url: "/faculty",
      title: "Awesome Teachers",
      text: "Vivamus interdum, mauris interdum quis curdum  sodales",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="43"
          viewBox="0 0 62 43"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M47.2214 5.57034C46.7589 5.41413 46.257 5.66264 46.1005 6.12701C45.9442 6.59137 46.1925 7.09515 46.6551 7.25206L59.2755 11.5332L53.3349 14.4403C53.0882 14.2733 52.8114 14.1451 52.5112 14.0664L34.6924 9.39212C34.126 6.46735 30.5383 5.23981 28.3347 7.32129C27.572 8.04175 27.1346 9.05769 27.1346 10.1087V10.1281C27.1408 11.3656 28.1612 12.3723 29.4094 12.3723H32.4859C33.2803 12.3723 34.0749 11.9562 34.4869 11.1729L51.1041 15.5321L32.5641 24.6048C31.5035 25.1238 30.3217 25.0897 29.331 24.6048L2.61951 11.5332L29.7664 2.32427C30.528 2.06582 31.3671 2.06582 32.1286 2.32427L42.7274 5.91979C43.1902 6.0766 43.6918 5.82773 43.8483 5.36312C44.0046 4.89876 43.7563 4.39499 43.2937 4.23807L32.6948 0.642547C31.568 0.260427 30.3271 0.260427 29.2002 0.642547L1.93156 9.8927C0.482811 10.3845 0.35206 12.3985 1.72901 13.0723L15.7235 19.9206C14.9536 23.5944 13.7781 27.5497 12.5006 31.0604C11.9776 32.4961 12.4282 34.0932 13.6216 35.0347C17.6602 38.2208 22.4321 40.682 27.323 42.2641C29.6213 43.0074 32.1841 43.036 34.5716 42.2641C39.4639 40.6813 44.2363 38.2191 48.2728 35.0347C49.4706 34.0895 49.9151 32.4917 49.3938 31.0604C48.1433 27.6276 46.9518 23.6465 46.171 19.9209L52.7539 16.6996V30.0578C51.6287 30.1443 50.7391 31.0888 50.7391 32.2399V34.8263C50.7391 35.2106 50.9053 35.5558 51.1682 35.7962L50.8398 40.7809C50.7756 41.7548 51.547 42.5824 52.5197 42.5824H54.7567C55.7289 42.5824 56.5007 41.7551 56.4366 40.7809L56.1082 35.7962C56.3711 35.5558 56.5374 35.2107 56.5374 34.8263V32.2398C56.5374 31.0887 55.6476 30.1442 54.5225 30.0577V16.6803C54.5225 16.4075 54.4797 16.1433 54.4033 15.8924L60.166 13.0724C61.5412 12.3994 61.4146 10.3852 59.9634 9.8927L47.2214 5.57034ZM32.4859 10.5972H29.4094C29.1362 10.5972 28.9043 10.3783 28.903 10.1236V10.1087C28.903 9.53688 29.1315 9.00612 29.5466 8.61394C30.8201 7.41102 32.9069 8.27691 32.9896 10.007C33.0093 10.4213 32.7435 10.5972 32.4859 10.5972ZM32.8444 35.6635C35.1798 35.2167 41.9598 32.5319 46.7373 28.7789C46.019 26.5745 45.1869 23.7417 44.5328 20.7225L33.3391 26.2002C31.7904 26.9582 30.0464 26.9297 28.5559 26.2002L17.3616 20.7223C16.7075 23.7416 15.8753 26.5744 15.1572 28.7787C20.0416 32.614 26.8447 35.242 29.0495 35.6639C29.5291 35.7557 29.8438 36.2205 29.7523 36.7021C29.6608 37.1835 29.1983 37.4991 28.7179 37.4075C26.139 36.9137 19.4644 34.2383 14.5589 30.5547C14.4482 30.8724 14.3057 31.2735 14.1772 31.6268L14.1618 31.6697C13.902 32.3825 14.1246 33.1736 14.7145 33.6391C19.4765 37.3955 24.4944 39.4839 27.8654 40.5743C29.8287 41.2096 32.0156 41.2257 34.0291 40.5743C37.4001 39.484 42.418 37.3955 47.18 33.6391C47.77 33.1734 47.9922 32.3822 47.7328 31.6698C47.6023 31.3113 47.4592 30.9086 47.3356 30.5549C42.3113 34.3289 35.6185 36.9396 33.1757 37.4071C32.6974 37.4991 32.233 37.1832 32.1415 36.7016C32.05 36.2202 32.3647 35.7554 32.8444 35.6635ZM52.6103 40.8073L52.9179 36.1401H54.3584L54.6659 40.8073H52.6103ZM54.7688 34.3648V32.2396C54.7688 32.0144 54.5791 31.8243 54.3547 31.8241H52.9215C52.697 31.8241 52.5075 32.0144 52.5075 32.2396V34.3648H54.7688Z"
            fill="url(#paint0_linear_47_5)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_47_5"
              x1="0.766968"
              y1="0.355957"
              x2="0.766968"
              y2="42.8324"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FDC830" />
              <stop offset="1" stop-color="#F37335" />
            </linearGradient>
          </defs>
        </svg>
      ),
    },
    {
      icon: `${require("../images/home/global.png")}`,
      url: "/activities",
      title: "Global Certificate",
      text: "Pelleneget  tespharetra que fringilla egugue id eget pharetra",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M42.8767 12.3907C42.8767 12.6484 42.7365 12.8862 42.5107 13.0101L41.4608 13.5899V21.0163C42.2827 21.3094 42.8767 22.0881 42.8767 23.0099V28.6734C42.8767 29.0642 42.5595 29.3814 42.1687 29.3814H39.337C38.9462 29.3814 38.629 29.0642 38.629 28.6734V23.0099C38.629 22.0881 39.223 21.3094 40.0449 21.0163V14.3708L37.2132 15.9332V31.5052H42.1687C42.5595 31.5052 42.8767 31.8224 42.8767 32.2132V42.1244C42.8767 42.5152 42.5595 42.8324 42.1687 42.8324H35.0893H31.5496H1.10821C0.717426 42.8324 0.400269 42.5152 0.400269 42.1244V32.2132C0.400269 31.8224 0.717426 31.5052 1.10821 31.5052H6.06379V15.9332L0.766274 13.0101C0.540441 12.8862 0.400269 12.6484 0.400269 12.3907C0.400269 12.133 0.540441 11.8951 0.766274 11.7712L21.2965 0.444096C21.5096 0.326577 21.7673 0.326577 21.9804 0.444096L42.5107 11.7712C42.7365 11.8951 42.8767 12.133 42.8767 12.3907ZM40.0449 23.0098V27.9654H41.4608V23.0098C41.4608 22.6197 41.1429 22.3019 40.7528 22.3019C40.3627 22.3019 40.0449 22.6197 40.0449 23.0098ZM21.6384 1.87192L40.7032 12.3906L21.6384 22.9092L2.57358 12.3906L21.6384 1.87192ZM30.8417 32.9212H1.81619V41.4165H30.8417V40.0006H24.4703C24.1843 40.0006 23.9259 39.8279 23.8161 39.5638C23.7064 39.299 23.7673 38.9946 23.9698 38.7921L25.5931 37.1688L23.9698 35.5455C23.7673 35.343 23.7064 35.0386 23.8161 34.7738C23.9259 34.5098 24.1843 34.337 24.4703 34.337H30.8417V32.9212ZM27.0946 36.6681L26.1792 35.7528H30.8417V38.5846H26.1792L27.0946 37.6692C27.3714 37.3924 27.3714 36.945 27.0946 36.6681ZM34.3814 32.9212H32.2575V41.4165H34.3814V32.9212ZM41.4606 41.4165H35.7971V32.9212H41.4606V41.4165ZM35.0893 31.5052H35.7972V16.7141L21.9804 24.3373C21.8742 24.396 21.7567 24.4258 21.6384 24.4258C21.5202 24.4258 21.4027 24.396 21.2965 24.3373L7.47964 16.7141V27.9655H11.7273V29.3814H7.47964V31.5052H31.5496H35.0893Z"
            fill="url(#paint0_linear_47_17)"
          />
          <path
            d="M13.2719 28.0298H14.559V29.3169H13.2719V28.0298Z"
            fill="url(#paint1_linear_47_17)"
          />
          <path
            d="M15.8462 28.0298H17.1334V29.3169H15.8462V28.0298Z"
            fill="url(#paint2_linear_47_17)"
          />
          <path
            d="M19.0641 28.0298H20.3513V29.3169H19.0641V28.0298Z"
            fill="url(#paint3_linear_47_17)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.9603 10.0096C23.5843 10.0096 24.8564 10.9993 24.8564 12.2622C24.8564 13.5251 23.5843 14.5147 21.9603 14.5147C20.3363 14.5147 19.0641 13.5251 19.0641 12.2622C19.0641 10.9993 20.3363 10.0096 21.9603 10.0096ZM21.9601 11.5113C21.076 11.5113 20.512 11.9558 20.512 12.2622C20.512 12.5685 21.076 13.013 21.9601 13.013C22.8441 13.013 23.4081 12.5685 23.4081 12.2622C23.4081 11.9558 22.8441 11.5113 21.9601 11.5113Z"
            fill="url(#paint4_linear_47_17)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_47_17"
              x1="-9.86367"
              y1="-10.3564"
              x2="-5.23451"
              y2="49.7445"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_47_17"
              x1="12.9608"
              y1="27.7052"
              x2="13.1011"
              y2="29.5264"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_47_17"
              x1="15.5352"
              y1="27.7052"
              x2="15.6754"
              y2="29.5264"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_47_17"
              x1="18.7531"
              y1="27.7052"
              x2="18.8934"
              y2="29.5264"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_47_17"
              x1="17.6645"
              y1="8.87348"
              x2="18.0473"
              y2="15.2627"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
          </defs>
        </svg>
      ),
    },
    {
      icon: `${require("../images/home/best.png")}`,
      url: "/admission",
      title: "Best Program ",
      text: "Etiam risus neque, volutpat vel laoreet a, finibus volutpat non ligula",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="39"
          height="43"
          viewBox="0 0 39 43"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.8907 25.7421C17.6034 25.7421 15.7426 23.8813 15.7426 21.594C15.7426 19.3068 17.6034 17.4459 19.8907 17.4459C22.1779 17.4459 24.0388 19.3068 24.0388 21.594C24.0388 23.8813 22.1779 25.7421 19.8907 25.7421ZM22.3795 21.5939C22.3795 20.2216 21.263 19.1051 19.8906 19.1051C18.5183 19.1051 17.4018 20.2216 17.4018 21.5939C17.4018 22.9663 18.5183 24.0828 19.8906 24.0828C21.263 24.0828 22.3795 22.9663 22.3795 21.5939Z"
            fill="url(#paint0_linear_47_18)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.92858 31.9645C0.223797 29.0126 3.86938 24.7387 6.32041 22.3678C1.82222 18.2131 0.0134891 14.5408 1.35191 12.2228C3.22303 8.98165 9.67546 10.4813 13.2398 11.6526C13.6091 9.52165 14.0894 7.62199 14.648 6.0809C14.2884 5.64203 14.0832 5.08602 14.0832 4.50404C14.0832 3.13169 15.1997 2.01519 16.5721 2.01519C16.6576 2.01519 16.7426 2.02 16.8269 2.02863C17.7642 0.919184 18.7928 0.355957 19.8905 0.355957C23.6162 0.355957 25.5396 6.9257 26.2949 10.557C29.7982 9.4445 36.1331 8.03747 37.9728 11.224C39.9321 14.6171 34.8314 19.7711 31.843 22.3226C33.1057 23.4299 34.1836 24.5151 35.0601 25.5611C35.6199 25.4693 36.2036 25.5695 36.7073 25.86C37.8961 26.5464 38.3047 28.0715 37.6185 29.2599C37.5756 29.3342 37.5282 29.4047 37.4787 29.4733C37.9711 30.8394 37.9448 32.0118 37.3965 32.9629C35.5924 36.0896 29.509 34.8028 26.0498 33.7341C25.2422 37.1249 23.3555 42.8324 19.8905 42.8324C18.8203 42.8324 17.8104 42.2723 16.8887 41.1676C16.5951 40.8158 16.6423 40.2926 16.9942 39.9991C17.3459 39.7055 17.8691 39.7529 18.1626 40.1047C18.7542 40.8136 19.3356 41.1731 19.8905 41.1731C22.235 41.1731 23.9367 35.4861 24.4687 33.2105C22.5478 32.5314 20.566 31.6789 18.5623 30.669C17.3819 31.205 16.2118 31.685 15.0708 32.1013C15.1754 32.6168 15.2873 33.1207 15.4061 33.6043C15.5155 34.0492 15.2434 34.4985 14.7984 34.6079C14.352 34.7175 13.9038 34.4436 13.7948 34.0001C13.6871 33.5614 13.5851 33.1065 13.4885 32.6427C12.074 33.0937 10.7404 33.4292 9.50721 33.6438C9.3057 34.1752 8.92681 34.6297 8.42415 34.9196C7.23481 35.6064 5.71039 35.1952 5.02488 34.0088C4.98198 33.9349 4.94357 33.8589 4.90881 33.7814C3.4798 33.5246 2.47778 32.9154 1.92858 31.9645ZM7.56663 23.4713C4.17648 26.725 2.53417 29.6951 3.36545 31.1346C3.6481 31.624 4.21249 31.901 4.79596 32.0576C4.97457 31.4587 5.37495 30.9321 5.93593 30.6085C7.12394 29.9231 8.64903 30.3317 9.33595 31.519C9.41626 31.6583 9.48064 31.8038 9.53232 31.9529C10.6618 31.7398 11.8827 31.4207 13.1788 30.9996C12.9771 29.8059 12.8139 28.5598 12.6917 27.2814C10.8215 26.0569 9.10208 24.7784 7.56663 23.4713ZM14.5783 13.8896C15.2945 14.1635 16.0221 14.4632 16.7569 14.7866C15.9689 15.2299 15.184 15.6927 14.3207 16.2322C14.3916 15.4372 14.4775 14.6548 14.5783 13.8896ZM25.5665 17.6586C25.4534 15.9609 25.2694 14.3183 25.0141 12.7518C23.5245 13.3032 21.9998 13.9604 20.4585 14.7149C22.1814 15.6005 23.8958 16.5894 25.5665 17.6586ZM24.8149 31.5726C23.3974 31.0632 21.9446 30.4554 20.4731 29.7568C22.1118 28.9365 23.7605 28.0178 25.4541 26.961C25.3056 28.5691 25.0918 30.1123 24.8149 31.5726ZM29.2365 22.307C28.6368 21.8287 28.0075 21.3518 27.3526 20.8788C27.3554 21.1169 27.3572 21.3554 27.3571 21.5941C27.3571 22.3038 27.3433 23.018 27.3185 23.7309C27.9807 23.2627 28.6212 22.7873 29.2365 22.307ZM25.6679 19.708C25.6875 20.3291 25.6978 20.9611 25.6978 21.5941C25.6978 22.6916 25.6654 23.8001 25.6048 24.8961C23.4191 26.3251 21.0372 27.6713 18.5998 28.8229C17.1611 28.0733 15.7527 27.2661 14.273 26.3261C14.1476 24.7756 14.0832 23.1861 14.0832 21.5941C14.0832 20.5064 14.115 19.3987 14.1744 18.2953C15.5836 17.3722 17.0866 16.4774 18.6264 15.6535C21.0346 16.8273 23.4371 18.2164 25.6679 19.708ZM16.6862 29.6807C15.8813 29.2383 15.2503 28.8736 14.4815 28.408C14.5647 29.1008 14.6606 29.7805 14.7686 30.4442C15.3998 30.2092 16.04 29.9545 16.6862 29.6807ZM12.5297 25.1741C11.1911 24.2526 9.94284 23.3048 8.79987 22.3416C9.9104 21.3687 11.1361 20.4058 12.4621 19.4638C12.4378 20.1778 12.4242 20.8901 12.4242 21.5941C12.4242 22.7934 12.4601 23.9915 12.5297 25.1741ZM6.46102 33.1776C6.69049 33.5748 7.1988 33.7112 7.59486 33.4824C7.98503 33.2574 8.13237 32.7532 7.89916 32.3489C7.6706 31.9538 7.16188 31.8169 6.76499 32.0457C6.3691 32.2741 6.2337 32.7855 6.46102 33.1776ZM36.1826 28.429C35.9472 28.8353 35.4372 28.9585 35.0483 28.7336C34.6508 28.5043 34.5156 27.9974 34.7446 27.6013C34.9771 27.1994 35.4877 27.0716 35.8782 27.297C36.2743 27.5257 36.4106 28.034 36.1826 28.429ZM33.3083 26.7708C33.3883 26.6324 33.4815 26.5047 33.584 26.3862C32.7514 25.4226 31.733 24.4191 30.5436 23.3907C29.4996 24.2182 28.3821 25.0326 27.2112 25.8208C27.0567 28.0329 26.785 30.1414 26.4019 32.1058C31.9961 33.8549 35.2261 33.4049 35.9596 32.1338C36.242 31.6442 36.1993 31.0165 36.0429 30.4328C35.3898 30.5879 34.7444 30.4743 34.2188 30.1705C33.0288 29.4843 32.6191 27.9636 33.3083 26.7708ZM36.5361 12.0535C37.9054 14.4247 32.6645 19.4621 30.5561 21.2382C29.5455 20.4194 28.451 19.6041 27.2921 18.8056C27.1872 16.5034 26.9564 14.2865 26.6034 12.1997C32.4238 10.312 35.7793 10.7426 36.5361 12.0535ZM18.5902 13.7977C20.6628 12.726 22.7174 11.8193 24.7128 11.0954C23.4482 4.83033 21.4023 2.01519 19.8906 2.01519C19.3257 2.01519 18.8035 2.3657 18.3761 2.79279C18.8052 3.247 19.0609 3.85677 19.0609 4.50404C19.0609 5.87639 17.9444 6.99289 16.5721 6.99289C16.4126 6.99289 16.2554 6.97613 16.1015 6.9466C15.5977 8.40863 15.1639 10.2014 14.8284 12.21C16.0559 12.6681 17.3171 13.2007 18.5902 13.7977ZM16.5722 3.67434C17.0415 3.67434 17.4018 4.05903 17.4018 4.50396C17.4018 4.96141 17.0296 5.33358 16.5722 5.33358C16.1181 5.33358 15.7426 4.96357 15.7426 4.50396C15.7426 4.04651 16.1147 3.67434 16.5722 3.67434ZM12.9815 13.3143C7.00784 11.2993 3.56477 11.7083 2.78899 13.0523C1.55278 15.1931 5.73671 19.5776 7.54369 21.2369C9.02971 19.9211 10.7152 18.6242 12.5674 17.372C12.6615 15.9838 12.8001 14.6234 12.9815 13.3143Z"
            fill="url(#paint1_linear_47_18)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_47_18"
              x1="15.7426"
              y1="17.4459"
              x2="15.7426"
              y2="25.7421"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FDC830" />
              <stop offset="1" stop-color="#F37335" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_47_18"
              x1="0.920502"
              y1="0.355957"
              x2="0.920502"
              y2="42.8324"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FDC830" />
              <stop offset="1" stop-color="#F37335" />
            </linearGradient>
          </defs>
        </svg>
      ),
    },
    {
      icon: `${require("../images/home/student.png")}`,
      url: "https://india.afs.org/",
      title: "Intercultural Program India",
      text: "Mauris nec mi fequis ugiat, cursus tortor nec, pharetra tellus",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.3455 25.2559H28.9925C31.0138 25.2582 32.6519 26.8963 32.6543 28.9176V34.7764C32.6519 36.7977 31.0138 38.4358 28.9925 38.4382H14.3455C12.3242 38.4358 10.6861 36.7977 10.6837 34.7764V28.9176C10.6861 26.8963 12.3242 25.2582 14.3455 25.2559ZM28.9924 36.9735C30.2058 36.9735 31.1895 35.9898 31.1895 34.7764V31.1147H18.0072V34.7764C18.0072 35.1809 17.6792 35.5088 17.2748 35.5088H14.3454C13.941 35.5088 13.613 35.1809 13.613 34.7764V31.1147H12.1483V34.7764C12.1483 35.9898 13.132 36.9735 14.3454 36.9735H28.9924ZM15.0777 34.0441V31.1147H16.5424V34.0441H15.0777ZM12.1483 29.6499H31.1895V28.9175C31.1895 27.7041 30.2058 26.7205 28.9924 26.7205H14.3454C13.132 26.7205 12.1483 27.7041 12.1483 28.9175V29.6499Z"
            fill="url(#paint0_linear_1_1227)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M37.7811 22.3265H36.6372L36.6093 20.8435C36.5873 19.98 36.4892 19.12 36.3164 18.2737V3.28536C36.3164 2.88092 35.9885 2.55301 35.584 2.55301H31.1899C31.1826 2.55301 31.1767 2.55301 31.1687 2.55741C30.9896 2.56143 30.8185 2.63229 30.689 2.75587C30.6763 2.76813 30.6662 2.7817 30.6561 2.79532L30.6561 2.79537C30.6493 2.80452 30.6424 2.8137 30.6348 2.82252C30.6052 2.85337 30.5782 2.88669 30.5542 2.92212L27.879 7.60624C27.8337 7.58504 27.7889 7.56285 27.7441 7.54066C27.6728 7.50535 27.6015 7.47001 27.5282 7.43853V6.21477C27.5282 2.97906 24.9051 0.355957 21.6694 0.355957C18.4336 0.355957 15.8105 2.97906 15.8105 6.21477V7.4356C15.7372 7.46708 15.6659 7.50242 15.5946 7.53773C15.5498 7.55992 15.505 7.58211 15.4597 7.60331L12.7845 2.91919C12.7609 2.88449 12.7345 2.8519 12.7054 2.82179C12.6879 2.79643 12.669 2.77199 12.649 2.74855C12.5193 2.62524 12.3483 2.55475 12.1693 2.55082C12.1624 2.55118 12.1556 2.55191 12.1488 2.55301H7.75467C7.35023 2.55301 7.02232 2.88092 7.02232 3.28536V18.2737H7.02671C6.85388 19.12 6.75583 19.98 6.73377 20.8435L6.70155 22.3265H5.55761C2.72772 22.3297 0.434356 24.6231 0.431152 27.453V38.4382C0.431152 38.8427 0.759063 39.1706 1.1635 39.1706H6.35808C6.3524 41.1872 7.98261 42.8267 9.99933 42.8324H10.0132H33.3255C35.3422 42.8344 36.9786 41.2012 36.9806 39.1845V39.1706H42.1752C42.5796 39.1706 42.9076 38.8427 42.9076 38.4382V27.453C42.9043 24.6231 40.611 22.3297 37.7811 22.3265ZM6.38121 37.7058H1.89556V29.65H6.54892L6.38121 37.7058ZM1.89556 28.1853H6.58261L6.67122 23.7912H5.55732C3.53602 23.7936 1.89794 25.4317 1.89556 27.4529V28.1853ZM31.9223 4.01755H34.8517V14.1928C34.0879 12.7616 33.0988 11.4626 31.9223 10.3458V4.01755ZM30.4575 9.12934V6.04321L29.1766 8.28421C29.6175 8.54429 30.045 8.82633 30.4575 9.12934ZM17.2749 6.21462C17.2749 3.78779 19.2422 1.82051 21.669 1.82051C24.0958 1.82051 26.0631 3.78779 26.0631 6.21462V6.88618C23.2021 5.99079 20.1359 5.99079 17.2749 6.88618V6.21462ZM14.1617 8.28421L12.8808 6.04321V9.12934C13.2934 8.82633 13.7208 8.54429 14.1617 8.28421ZM8.48669 4.01755H11.4161V10.3458C10.2396 11.4626 9.25045 12.7616 8.48669 14.1928V4.01755ZM33.3217 41.3675C33.3372 41.3675 33.3528 41.3674 33.3683 41.3671C34.5815 41.3415 35.5442 40.3375 35.5188 39.1243L35.1387 20.8741C34.9881 13.6521 29.1695 7.83352 21.9474 7.68284C14.5068 7.52758 8.34917 13.4335 8.194 20.8741L7.81611 39.1251C7.81583 39.1404 7.81565 39.1557 7.81565 39.1709C7.81592 40.3844 8.79975 41.3678 10.0132 41.3675H33.3217ZM41.4426 37.7058H36.9577L36.7892 29.65H41.4426V37.7058ZM36.7555 28.1853H41.4426V27.4529C41.4402 25.4317 39.8021 23.7936 37.7808 23.7912H36.664L36.7555 28.1853Z"
            fill="url(#paint1_linear_1_1227)"
          />
          <rect
            x="19.4721"
            y="14.9766"
            width="1.4647"
            height="2.92941"
            fill="url(#paint2_linear_1_1227)"
          />
          <rect
            x="22.4018"
            y="14.9766"
            width="1.4647"
            height="2.92941"
            fill="url(#paint3_linear_1_1227)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.4821 11.3566L26.7513 14.6265C27.7519 15.6274 27.7519 17.25 26.7513 18.2509L23.4821 21.5209C22.4802 22.52 20.8588 22.52 19.8569 21.5209L16.5877 18.2538C15.587 17.2529 15.587 15.6304 16.5877 14.6294L19.8569 11.3566C20.8714 10.3885 22.4676 10.3885 23.4821 11.3566ZM22.4466 20.4881L25.7158 17.2152C26.1447 16.7863 26.1447 16.0909 25.7158 15.6619L22.4466 12.392C22.0176 11.9631 21.3222 11.9631 20.8932 12.392L17.6233 15.6619L17.6206 15.6646C17.1923 16.0944 17.1936 16.7899 17.6233 17.2182L20.8925 20.4881L20.893 20.4886C21.3221 20.9175 22.0177 20.9173 22.4466 20.4881Z"
            fill="url(#paint4_linear_1_1227)"
          />
          <rect
            x="3.36047"
            y="5.48242"
            width="1.4647"
            height="9.52057"
            fill="url(#paint5_linear_1_1227)"
          />
          <rect
            x="3.36047"
            y="16.4675"
            width="1.4647"
            height="1.4647"
            fill="url(#paint6_linear_1_1227)"
          />
          <rect
            x="37.7811"
            y="12.8058"
            width="1.4647"
            height="5.85881"
            fill="url(#paint7_linear_1_1227)"
          />
          <rect
            x="37.7811"
            y="9.87634"
            width="1.4647"
            height="1.4647"
            fill="url(#paint8_linear_1_1227)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1_1227"
              x1="5.37481"
              y1="21.9313"
              x2="6.24005"
              y2="40.654"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_1_1227"
              x1="-9.83278"
              y1="-10.3564"
              x2="-5.20362"
              y2="49.7445"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_1_1227"
              x1="19.1182"
              y1="14.2378"
              x2="19.7456"
              y2="18.3106"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_1_1227"
              x1="22.0478"
              y1="14.2378"
              x2="22.6752"
              y2="18.3106"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_1_1227"
              x1="13.0186"
              y1="7.69501"
              x2="14.2844"
              y2="24.1647"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_1_1227"
              x1="3.00654"
              y1="3.08138"
              x2="8.4311"
              y2="13.9164"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_1_1227"
              x1="3.00654"
              y1="16.0981"
              x2="3.16617"
              y2="18.1706"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_1_1227"
              x1="37.4272"
              y1="11.3282"
              x2="39.7736"
              y2="18.9443"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_1_1227"
              x1="37.4272"
              y1="9.50695"
              x2="37.5868"
              y2="11.5794"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0E6BA8" />
              <stop offset="1" stop-color="#155799" />
            </linearGradient>
          </defs>
        </svg>
      ),
    },
  ],

  studentAchiev: [
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Aaradhy R Gor (U-11, Boys) got 2nd position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Reet J Vasava (U-11, Boys) got 3rd position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Aadity M Solanki (U-11, Boys) got 4th position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Amee B Prajapati (U-11, Girls) got 2nd position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Verse D Patel (U-14, Boys) got 1st position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Shlok M Patel (U-14, Boys) got 2nd position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Roumyadeep Maiti (U-17, Boys) got 2nd position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Dweep J Patel (U-17, Boys) got 3rd position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Priyansh B Prajapati (U-19, Boys) got 1st position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Parth C Patel (U-19, Boys) got 2nd position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Parth C Vaghela (U-19, Boys) got 3rd position at District Level (SGFI)",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Reet J Vasava (U-11, Boys) got 1st position (500mtrs : 1, 1000mtrs : 1 - Quad) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Aadity M Solanki (U-11, Boys) got 3rd position (500mtrs : 3 - Quad) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Aaradhy R Gor (U-11, Boys) participated (1000mtrs : 4 - Quad) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Amee B Prajapati (U-11, Girls) got 2nd position (500mtrs : 2, 1000mtrs : 2 - Quad) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Verse D Patel (U-14, Boys) got 1st position (500mtrs : 3, 1000mtrs : 1 - Quad) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Shlok M Patel (U-14, Boys) got 2nd position (500mtrs : 1 - Quad) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Dweep J Patel (U-17, Boys) got 2nd position (1000mtrs : 2 - Quad) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Priyansh B Prajapati (U-17, Boys) got 3rd position (500mtrs : 2 - Quad) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Roumyadeep Maiti (U-17, Boys) got 4th position (1000mtrs : 3 - Quad) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Parth C Patel (U-17, Boys) got 4th position (500mtrs : 3 - Quad) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Ved H Shinde (U-17, Boys) got 1st position (500mtrs : 2, 1000mtrs : 1 - Inline) in Khel Mahakumbh",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Skating <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Ved H Shinde has been selected for National Competition",
      icon: `${require("../images/home/IceSkating.png")}`,
    },
    {
      studentName: (
        <p>
          Karate <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Ved shinde & Shyam Patel (U-17) got 1st position at District Level (SGFI)",
      icon: `${require("../images/home/Karate.png")}`,
    },
    {
      studentName: (
        <p>
          Karate <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Dhanvinsinh M Chavda (U-14, -30kg) got 1st position in District (SGFI)",
      icon: `${require("../images/home/Karate.png")}`,
    },
    {
      studentName: (
        <p>
          Karate <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Mantra Darji (U-14, -30kg) got 2nd position in District (SGFI)",
      icon: `${require("../images/home/Karate.png")}`,
    },
    {
      studentName: (
        <p>
          Karate <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Nagesh Malviya (U-14, -30kg) got 3rd position in District (SGFI)",
      icon: `${require("../images/home/Karate.png")}`,
    },
    {
      studentName: (
        <p>
          Karate <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Jainil Seth (U-14, -35kg) got 2nd position in District (SGFI)",
      icon: `${require("../images/home/Karate.png")}`,
    },
    {
      studentName: (
        <p>
          Karate <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Alin Parmar (U-14, -60kg) got 2nd position in District (SGFI)",
      icon: `${require("../images/home/Karate.png")}`,
    },
    {
      studentName: (
        <p>
          Karate <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Priyansh B Parajapati (U-17, -45kg) got 3rd position in District (SGFI)",
      icon: `${require("../images/home/Karate.png")}`,
    },
    {
      studentName: (
        <p>
          Karate <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Ved Shinde (U-17, -50kg) got 3rd position in District (SGFI)",
      icon: `${require("../images/home/Karate.png")}`,
    },
    {
      studentName: (
        <p>
          Karate <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Jenalyn V Parmar (U-17, -42kg) got 2nd position in District (SGFI)",
      icon: `${require("../images/home/Karate.png")}`,
    },
    {
      studentName: (
        <p>
          Chess <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Nishil B Patel (U-14) got 1st position (2 times) at District Level (SGFI)",
      icon: `${require("../images/home/Chess.png")}`,
    },

    {
      studentName: (
        <p>
          Badminton <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Manvi Bhargav (U-14) got 3rd position (2 times) at District Level (SGFI)",
      icon: `${require("../images/home/Badminton.png")}`,
    },
    {
      studentName: (
        <p>
          Badminton <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results:
        "Bhavya Patel (U-17) got 3rd position (2 times) at District Level (SGFI)",
      icon: `${require("../images/home/Badminton.png")}`,
    },
    {
      studentName: (
        <p>
          Badminton <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Jainil Patel (U-17) got 4th position at District Level (SGFI)",
      icon: `${require("../images/home/Badminton.png")}`,
    },
  ],

  studentAchievment: [
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 1 - Aayushi G Solanki has got Gold Medal in IGKO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "   Class 3 - Jeet D Shah has got Gold Medal in IEO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 3 - Riya S Vohra has got Gold Medal in IEO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 8 - Zalak B Amin has got Gold Medal in IEO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 1 - Viaan S Amin has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 2 - Mo.Adeeb Vahora has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 3 - Jeet D Shah has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 3 - Shwet B Bhatt has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 3 - Krishiv K Patel has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 4 - Nand B Patel has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 4 - Aaradhya R Gor has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 4 - Rutva K Rami has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 5 - Hriday N Garasiya has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 6 - Kavya S Patel has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 7 - Vrund H Patel has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 8 - Vedant C Patel has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 9 - Vyom P Patel has got Gold Medal in IMO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 3 - Shwet B Bhatt has got Gold Medal in NSO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 4 - Aaradhya R Gor has got Gold Medal in NSO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 5 - Shayaan Sonali Shaikh has got Gold Medal in NSO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 6 - Dhruv K Patel has got Gold Medal in NSO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 7 - Alin A Parmar has got Gold Medal in NSO",
      icon: `${require("../images/home/medal.png")}`,
    },
    {
      studentName: (
        <p>
          Science Olympiads Foundation{" "}
          <span style={{ fontSize: "18px" }}>2024-25</span>
        </p>
      ),
      results: "Class 8 - Priyanshu H Vadhiya has got Gold Medal in NSO",
      icon: `${require("../images/home/medal.png")}`,
    },
  ],

  ourManagement: [
    {
      name: "Madhumita Jana",
      img: `${require("../images/home/MadhumitaJana.png")}`,
      post: "Founder & Director",
      id: "madhumitaJana",
    },
    {
      name: "Mr. Prayasvin B. Patel",
      img: `${require("../images/home/Prayasvin.jpg")}`,
      post: "Trustee",
      id: "prayasvin",
    },
    {
      name: "Dr. Atanu Jana",
      img: `${require("../images/home/atanu.png")}`,
      post: "Trustee",
      id: "atanu",
    },
  ],

  newsBlog: [
    {
      img: `${require("../images/home/blog1.png")}`,
      date: "17/09/2020",
      hows: "by Admin",
      publis: " Teachers, School",
      title: "Campus clean workshop",
      text: "Nam mattis felis id sodales rutrum. Nulla ornare tristique mauris, a laoreet erat ornare sit amet",
      url: "#",
    },
    {
      img: `${require("../images/home/blog2.png")}`,
      date: "17/09/2020",
      hows: "by Admin",
      publis: " Teachers, School",
      title: "Campus clean workshop",
      text: "Nam mattis felis id sodales rutrum. Nulla ornare tristique mauris, a laoreet erat ornare sit amet",
      url: "#",
    },
    {
      img: `${require("../images/home/blog3.png")}`,
      date: "17/09/2020",
      hows: "by Admin",
      publis: " Teachers, School",
      title: "Campus clean workshop",
      text: "Nam mattis felis id sodales rutrum. Nulla ornare tristique mauris, a laoreet erat ornare sit amet",
      url: "#",
    },
  ],

  gallery: [
    `${require("../images/infrastructur/infrastructur11.jpg")}`,
    `${require("../images/infrastructur/infrastructur10.jpg")}`,
    `${require("../images/infrastructur/infrastructur9.jpg")}`,
    `${require("../images/infrastructur/infrastructur1.jpg")}`,
    `${require("../images/infrastructur/infrastructur16.jpg")}`,
    `${require("../images/infrastructur/infrastructur17.jpg")}`,
    `${require("../images/infrastructur/infrastructur2.jpg")}`,
    `${require("../images/infrastructur/b8.jpg")}`,    
  ],

  testimonials: [
    {
      text: "Shristi School integrates morals and creativity, vital for my daughter Bhagwati's growth. Excellent experience!",
      // img :`${require('../images/home/pp1.png')}`,
      name: "Taruna Y. Vasava",
      class: "P/o Bhagwati & Vraj Vasava",
      backGround: `${require("../images/home/testimonialBg.png")}`,
    },
    {
      text: "In 2014, we began our journey with Shristi School, seeking quality education, a nurturing environment, and inclusivity. SEMS prioritizes children's development and values.",
      // img :`${require('../images/home/pp1.png')}`,
      name: "Nilofer Arpit Rathod",
      class: "",
      backGround: `${require("../images/home/testimonialBg.png")}`,
    },
    {
      text: "As a parent, I am happy with SEMS' dedicated staff and creative learning environment. Individualized attention builds confidence.",
      // img :`${require('../images/home/pp1.png')}`,
      name: "Kiran Solanki",
      class: "",
      backGround: `${require("../images/home/testimonialBg.png")}`,
    },
    {
      text: "We are grateful for SEMS' wonderful education and care. Remarkable dedication of teachers and staff. Our children flourish here.",
      // img :`${require('../images/home/pp1.png')}`,
      name: "Ankita and Naisarg Thakor",
      class: "",
      backGround: `${require("../images/home/testimonialBg.png")}`,
    },
    {
      text: "Activity-based learning has been one of the most valuable experiences for me, and I continue to apply it in my workplace. I am truly grateful to Shristi English Medium School for shaping me into who I am today.",
      // img :`${require('../images/home/pp1.png')}`,
      name: "Master Ravi Chauhan",
      class: "",
      backGround: `${require("../images/home/testimonialBg.png")}`,
    },
    {
      text: "I am thankful to the teachers and Madhumita Madam of Shristi English Medium School for their constant support and for being such inspiring mentors to me.",
      // img :`${require('../images/home/pp1.png')}`,
      name: "Dr. Hemal Makwana",
      class: "",
      backGround: `${require("../images/home/testimonialBg.png")}`,
    },
  ],
};

const topSlier = home.homeSlider;
const cards = home.iconCard;
const stuAchiv = home.studentAchiev;
const stuAchievement = home.studentAchievment;
const ourManagement = home.ourManagement;
const newsBlog = home.newsBlog;
const gallery = home.gallery;
const testimonials = home.testimonials;
// console.log(topSlier);

const Home = () => {
  const navigate = useNavigate();
  const [counterOn, setCounterOn] = useState(false);
  const boxesold = [
    {
      dataValue: 4,
      marginTop: 210,
      width: 180,
      height: 200,
      img: `${require("../images/infrastructur/infrastructur10.jpg")}`,
    },

    {
      dataValue: 6,
      marginTop: 10,
      width: 288,
      height: 370,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur14.jpg")}`,
    },
    {
      dataValue: 5,
      marginTop: 31,
      width: 184,
      height: 300,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur7.jpg")}`,
    },
    {
      dataValue: 8,
      marginTop: 74,
      width: 97,
      height: 88,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur6.jpg")}`,
    },
    {
      dataValue: 6,
      marginTop: 1,
      width: 360,
      height: 242,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur1.jpg")}`,
    },
    {
      dataValue: 4,
      marginTop: 20,
      width: 185,
      height: 196,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur6.jpg")}`,
    },
    {
      dataValue: 4,
      marginTop: 50,
      width: 82,
      height: 73,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur8.jpg")}`,
    },
    {
      dataValue: 6,
      marginTop: 58,
      width: 184,
      height: 248,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur12.jpg")}`,
    },
    {
      dataValue: 7,
      marginTop: 19,
      width: 182,
      height: 243,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur5.jpg")}`,
    },
    {
      dataValue: 4,
      marginTop: 109,
      width: 82,
      height: 76,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur15.jpg")}`,
    },
    // New images added below
  {
    dataValue: 5,
    marginTop: 30,
    width: 200,
    height: 220,
    padding: 15,
    img: `${require("../images/infrastructur/b8.jpg")}`,
  },  
  
  ];

  const boxes = [
    {
      dataValue: 4,
      marginTop: 210,
      width: 180,
      height: 200,
      img: `${require("../images/infrastructur/infrastructur10.jpg")}`,
    },

    {
      dataValue: 6,
      marginTop: 10,
      width: 288,
      height: 370,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur14.jpg")}`,
    },
    {
      dataValue: 5,
      marginTop: 31,
      width: 184,
      height: 300,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur7.jpg")}`,
    },
    {
      dataValue: 8,
      marginTop: 74,
      width: 207,
      height: 308,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur15.jpg")}`,
    },
    {
      dataValue: 6,
      marginTop: 1,
      width: 360,
      height: 242,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur1.jpg")}`,
    },
    {
      dataValue: 4,
      marginTop: 20,
      width: 185,
      height: 196,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur6.jpg")}`,
    },
    // {
    //     dataValue : 4,
    //     marginTop:50,
    //     marginLeft:50,
    //   width: 202,
    //   height: 203,
    //   padding:15,
    //   img :`${require('../images/infrastructur/infrastructur8.jpg')}`,

    // },
    {
      dataValue: 6,
      marginTop: 58,
      width: 184,
      height: 248,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur12.jpg")}`,
    },
    {
      dataValue: 7,
      marginTop: 19,
      width: 182,
      height: 243,
      padding: 15,
      img: `${require("../images/infrastructur/infrastructur5.jpg")}`,
    },
    //    {
    //      dataValue : 4,
    //      marginTop:109,
    //      width: 202,
    //      height: 206,
    //      padding:15,
    //      img :`${require('../images/infrastructur/infrastructur15.jpg')}`,

    //    },
      // New images added below
  {
    dataValue: 5,
    marginTop: 30,
    width: 200,
    height: 220,
    padding: 15,
    img: `${require("../images/infrastructur/b8.jpg")}`,
  },

  ];

  useEffect(() => {
    AOS.init({ duration: 1500 });

    const div = document.querySelector(".moving");
    div.addEventListener("mousemove", parallax);
    function parallax(e) {
      document.querySelectorAll(".testiImg").forEach((el) => {
        var moving_value = el.getAttribute("data-value");
        var x = (e.clientX * moving_value) / 250;
        var y = (e.clientY * moving_value) / 250;
        el.style.transform = "translateX(" + x + "px) translateY(" + y + "px)";
      });
    }
  });
  return (
    <div>
      {/* <div class='homTopSlider'>  
            <Carousel  infiniteLoop={true} showThumbs={false} showStatus={false} stopOnHover={false} swipeable={false}  >
                {topSlier?.map((el)=>{
                    return( 
                        <div class='row flex-column-reverse flex-lg-row mt-3'  >
                            <div class='col-lg-7 col-12 d-flex align-items-center '>
                                <div class='text-start p-4'  > 
                                    <p class='fw-bold display-4 ' data-aos="fade-up" dangerouslySetInnerHTML={{ __html: el.title }} ></p>
                                    <button class='btn mt-4' id='button'   >Explore More</button>
                                    <br /><br />
                                </div>
                            </div>
                            <div class='col-lg-5 col-12  '>
                                <img style={{width:'100%'}}  data-aos="zoom-in"src={el.img} alt="" />
                            </div>
                        </div>
                        )
                    })} 
            </Carousel> 
        </div> */}
      <div class="homTopSlider ">
        <div class="row flex-column-reverse flex-lg-row ">
          <div class="col-lg-6 col-12 d-flex align-items-center ">
            <div class="text-start p-4">
              <p class="fw-bold display-4 " data-aos="fade-up">
                A Tradition of{" "}
                <span style={{ color: "green", textDecoration: "underline" }}>
                  Excellence
                </span>{" "}
                that emphasizes on much and not many
              </p>
              {/* <p class='fs-5 py-3'  data-aos="fade-up" style={{maxWidth:'500px'}}>{el.text}</p> */}
              <button
                class="btn mt-4"
                id="button"
                onClick={() => navigate("/admission")}
              >
                Explore More
              </button>
              <br />
              <br />
            </div>
          </div>
          <div class="col-lg-6 col-12   ">
            {/* <Carousel  infiniteLoop={true} showThumbs={false} showStatus={false} stopOnHover={false} swipeable={false} autoPlay={true} >
                                    {topSlier?.map((el)=>{
                                        return( 
                                            <div class='text-end'> 
                                                <img class='homeTopImg'  data-aos="zoom-in"src={el.img} alt="" />
                                             </div>
                                            )
                                    })} 
                            </Carousel>  */}
            <HomeTop images={topSlier} />
          </div>
        </div>
      </div>

      <div
        class="p-4"
        style={{
          backgroundImage: `url(${require("../images/home/secondSection.png")})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div class="row" style={{ width: "95%", margin: "auto" }}>
          <div class="col-md-6 col-12 p-3 text-start my-5">
            <p class="display-3 text-white fw-bold" data-aos="fade-up">
              Welcome to <span style={{ color: "#FFE65E" }}>Shristi</span>{" "}
            </p>
            <p class="text-white py-4 fs-5" data-aos="fade-up">
              Shristi English Medium School is a non-residential,
              co-educational, and secular Institution. The school campus is
              located in congenial and eco-friendly surroundings, away from the
              ‘hustle and bustle’ of the city; befitting learning surroundings.
              The school has ‘State-of-art’ facilities to make learning an
              enjoyable experience.
            </p>

            <button
              class="btn  "
              id="Readbutton"
              data-aos="fade-up"
              onClick={() => navigate("/about")}
            >
              Read More
            </button>
          </div>
          <div class="col-md-6 col-12 p-3 d-flex justify-content-end align-items-center gap-4">
            <div
              class="rounded-4 p-3 text-start"
              data-aos="zoom-in-up"
              style={{ background: "#30B74F", width: "180px" }}
            >
              <ScrollTrigger
                onEnter={() => setCounterOn(true)}
                onExit={() => setCounterOn(false)}
              >
                <p class="display-3 fw-semibold text-white d-flex">
                  <span>
                    {counterOn && <CountUp start={0} end={700} delay={0} />}
                  </span>
                  <span>+</span>
                </p>
              </ScrollTrigger>
              <p class="text-white">Students</p>
            </div>
            <div
              class="rounded-4 p-3 text-start"
              data-aos="zoom-in-up"
              style={{ background: "#FED217", width: "180px" }}
            >
              <ScrollTrigger
                onEnter={() => setCounterOn(true)}
                onExit={() => setCounterOn(false)}
              >
                <p class="display-3 fw-semibold   d-flex">
                  <span>
                    {counterOn && <CountUp start={0} end={200} delay={0} />}
                  </span>
                  <span>+</span>
                </p>
              </ScrollTrigger>
              <p class="">Alumni</p>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          background: "linear-gradient(#215395 50%, #ffffff 50%)",
          marginTop: "-2px",
        }}
      >
        <div
          class="row"
          data-aos="zoom-in-up"
          style={{ width: "95%", margin: "auto" }}
        >
          <HomeCard cards={cards} />
        </div>
      </div>

      <div class="mt-5">
        <div class="col-11 m-auto">
          <p class="display-3 fw-bold" data-aos="fade-up">
            School Achievments
          </p>
          {/* <p class='fs-5 my-3 ' data-aos="fade-up" style={{maxWidth:'800px',margin:'auto'}} >Nam mattis felis id sodales rutrum. Nulla ornare tristique mauris, a laoreet erat ornare sit amet. Nulla sagittis faucibus lacusMorbi lorem sem, aliquet</p> */}
          <div data-aos="zoom-in-up">
            <StudentAchiev stuAchiv={stuAchiv} />
          </div>
          <div data-aos="zoom-in-up">
            <StudentAchievment stuAchievement={stuAchievement} />
          </div>
        </div>
      </div>

      <div
        class=""
        data-aos="zoom-in-up"
        style={{
          backgroundImage: `url(${require("../images/home/ourManagement.png")})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div class="col-11 m-auto">
          <br />
          <br />
          <p class="display-3 fw-bold my-5" data-aos="fade-up">
            {" "}
            Our <br /> Management
          </p>
          <div class="d-flex justify-content-around flex-wrap gap-5 my-5 ">
            {ourManagement.map((el) => {
              return (
                <div data-aos="zoom-in-up">
                  <div>
                    <img
                      style={{
                        width: "300px",
                        height: "270px",
                        borderRadius: "25px",
                      }}
                      src={el.img}
                      alt=""
                    />
                  </div>
                  <div
                    class="d-flex justify-content-end"
                    style={{ marginTop: "-20px" }}
                  >
                    <Link to={`/about#${el.id}`}>
                      <button class="btn rounded-5 bg-light mx-4">
                        <i class="bi bi-chevron-right"></i>
                      </button>
                    </Link>
                  </div>
                  <div class="text-start">
                    <p class="fs-5 fw-bold">{el.name}</p>
                    <p class="">{el.post}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <br />
        </div>
      </div>

      {/* <div class='row '>
            <div class='col-lg-4 col-12 text-start p-0 d-flex align-items-center'>
                <div class='col-10 m-auto '>
                    <p class='display-3 fw-bold'  data-aos="fade-up">News & Blogs</p>
                    <p class='fs-5 my-3'  data-aos="fade-up" >Nam mattis felis id sodales rutrum. Nulla ornare tristique mauris, a laoreet erat ornare sit amet. Nulla sagittis faucibus lacusMorbi lorem sem, aliquet</p>
                </div>
            </div>
            <div class='col-lg-8 col-12 p-3 m-auto'>
                <NewsBlog newsBlog={newsBlog} />
            </div> 
        </div>  */}

      <div
        id="galleryLarg"
        style={{
          height: "975px",
          backgroundImage: `url(${require("../images/home/galleryBg.png")})`,
          backgroundSize: "110% 100%",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div class="col-12 m-auto">
          <br />
          <br />
          <p class="display-3  fw-bold my-5" data-aos="fade-up">
            {" "}
            Gallery{" "}
          </p>
          {/* <p class='m-auto fs-5 my-3'  data-aos="fade-up" style={{maxWidth:'600px'}}>Nam mattis felis id sodales rutrum. Nulla ornare tristique mauris, a laoreet erat ornare sit amet. Nulla sagittis faucibus lacusMorbi lorem sem, aliquet</p> */}
          <br />
          <div class="col-10 m-auto mt-5 moving ">
            <Masonry>
              {boxes.map((box, index) => (
                <div style={box}>
                  <img
                    class="testiImg"
                    data-value={box.dataValue}
                    style={{
                      height: "100%",
                      width: "100%",
                      borderRadius: "15px",
                      objectFit: "cover",
                    }}
                    src={box.img}
                    alt=""
                  />
                </div>
              ))}
            </Masonry>
          </div>
        </div>
      </div>

      <div
        id="gallerySmall"
        style={{
          backgroundImage: `url(${require("../images/home/galleryBg.png")})`,
          backgroundSize: "cover",
          objectFit: "fill",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div class="col-11 m-auto">
          <p class="display-3 fw-bold" data-aos="fade-up">
            {" "}
            Gallery{" "}
          </p>
          <p
            class="m-auto fs-5 my-3"
            data-aos="fade-up"
            style={{ maxWidth: "600px" }}
          >
            Nam mattis felis id sodales rutrum. Nulla ornare tristique mauris, a
            laoreet erat ornare sit amet. Nulla sagittis faucibus lacusMorbi
            lorem sem, aliquet
          </p>
          <Gallery gallery={gallery} />
        </div>
      </div>
      <br />

      <div>
        <p class="display-3 fw-bold" data-aos="fade-up">
          Our Testimonials
        </p>
        {/* <p class='m-auto fs-5 p-2 my-3' style={{maxWidth:'600px'}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore e</p> */}

        <div
          class=" mt-4 moving"
          style={{ background: "linear-gradient(#ffffff 50%, #215395 50%)" }}
        >
          <div class="col-lg-11 col-12 m-auto row">
            <div class="col-lg-4 col-12 testiHide my-5">
              <div class="d-flex justify-content-end">
                <img
                  class="testiImg"
                  data-value="5"
                  style={{
                    width: "80px",
                    borderRadius: "50%",
                    margin: "0 20px",
                  }}
                  src={require("../images/home/pp1.png")}
                  alt=""
                />
              </div>
              <div class="d-flex justify-content-start">
                <img
                  class="testiImg"
                  data-value="8"
                  style={{
                    width: "60px",
                    borderRadius: "50%",
                    margin: "0 20px",
                  }}
                  src={require("../images/home/pp2.png")}
                  alt=""
                />
              </div>
              <div class="d-flex justify-content-center ">
                <img
                  class="testiImg"
                  data-value="-8"
                  style={{
                    width: "70px",
                    borderRadius: "50%",
                    margin: "0 20px",
                  }}
                  src={require("../images/home/pp3.png")}
                  alt=""
                />
              </div>
              <div class="d-flex justify-content-end">
                <img
                  class="testiImg"
                  data-value="-5"
                  style={{
                    width: "75px",
                    borderRadius: "50%",
                    margin: "0 20px",
                  }}
                  src={require("../images/home/pp4.png")}
                  alt=""
                />
              </div>
            </div>

            <div
              class="col-lg-4 col-md-8 col-12  m-auto  testimonials rounded-5 my-5 "
              data-aos="fade-up"
            >
              <Carousel
                infiniteLoop={true}
                showThumbs={false}
                showStatus={false}
                stopOnHover={false}
                swipeable={false}
              >
                {testimonials?.map((el) => {
                  return (
                    <div
                      class="p-3 col-11 m-auto"
                      style={{
                        boxShadow: "0px 9px 23px rgba(0, 0, 0, 0.1)",
                        borderRadius: "20px",
                        background: "white",
                        backgroundImage: `url(${el.backGround})`,
                        backgroundSize: "cover",
                      }}
                    >
                      <div class="p-2">
                        <br />
                        <p
                          class="fs-5"
                          style={{
                            maxWidth: "500px",
                            margin: "auto",
                            color: "gray",
                          }}
                        >
                          {el.text}
                        </p>
                        <hr />
                      </div>
                      <div class="d-flex gap-3">
                        {/* <div>
                                            <img style={{width:'60px', borderRadius:'50%'}} src={el.img} alt="" />
                                        </div> */}
                        <div class="text-start px-3">
                          <p class="fs-5 fw-bold">{el.name}</p>
                          <p style={{ color: "gray" }}>{el.class}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Carousel>
            </div>

            <div class="col-lg-4 col-12  testiHide my-5">
              <div class="d-flex justify-content-start">
                <img
                  class="testiImg"
                  data-value="5"
                  style={{
                    width: "80px",
                    borderRadius: "50%",
                    margin: "0 20px",
                  }}
                  src={require("../images/home/pp5.png")}
                  alt=""
                />
              </div>
              <div class="d-flex justify-content-end">
                <img
                  class="testiImg"
                  data-value="4"
                  style={{
                    width: "60px",
                    borderRadius: "50%",
                    margin: "0 20px",
                  }}
                  src={require("../images/home/pp6.png")}
                  alt=""
                />
              </div>
              <div class="d-flex justify-content-center ">
                <img
                  class="testiImg"
                  data-value="-4"
                  style={{
                    width: "70px",
                    borderRadius: "50%",
                    margin: "0 20px",
                  }}
                  src={require("../images/home/pp7.png")}
                  alt=""
                />
              </div>
              <div class="d-flex justify-content-start">
                <img
                  class="testiImg"
                  data-value="-5"
                  style={{
                    width: "75px",
                    borderRadius: "50%",
                    margin: "0 20px",
                  }}
                  src={require("../images/home/pp8.png")}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
